var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImgGoBackPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.60952 8.625L7.13811 11.9331C7.39846 12.1771 7.39846 12.5729 7.13811 12.8169C6.87776 13.061 6.45565 13.061 6.1953 12.8169L1.52864 8.44194C1.26829 8.19786 1.26829 7.80214 1.52864 7.55806L6.1953 3.18306C6.45565 2.93898 6.87776 2.93898 7.13811 3.18306C7.39846 3.42714 7.39846 3.82286 7.13811 4.06694L3.60951 7.375L14 7.375C14.3682 7.375 14.6667 7.65482 14.6667 8C14.6667 8.34518 14.3682 8.625 14 8.625L3.60952 8.625Z",
    fill: "#7C01FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgGoBackPurple);
export default __webpack_public_path__ + "static/media/imgGoBackPurple.3e781d6692a361a031069b7486d2f2ce.svg";
export { ForwardRef as ReactComponent };